import {
  AlphabetsDraftApi,
  FusionMelcoModelsUserAlphabet,
  useAPIAction,
} from "melco-shared-logic";
import { useFormikContext } from "formik";
import { fontToInitialValues } from "../../../components/libraries/fonts/FontDetailForm";
import { QueryObserverResult } from "react-query";

export const useRevertFont = (
  fontId: string,
  refetch: () => Promise<
    QueryObserverResult<FusionMelcoModelsUserAlphabet, unknown>
  >
) => {
  const { resetForm } = useFormikContext();

  return useAPIAction(
    AlphabetsDraftApi,
    async (api) => {
      const data = await api.userAlphabetRevert({
        id: fontId,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "libraries.fonts.detail.revert",
      onSuccess: async () => {
        const refetchResult = await refetch();

        resetForm({
          values: refetchResult.data
            ? fontToInitialValues(refetchResult.data)
            : {},
        });
      },
    }
  );
};
